import { useEffect, useState } from "react";

export default function PageHeader({ label, title, description, children }) {
  return (
    <div className="px-10 pt-10 pb-6 border-b border-carbon-200 bg-page sticky top-0 z-10">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="section-label mb-2">{label}</div>
          <h1 className="font-heading text-3xl font-medium tracking-tight">{title}</h1>
          {description && <p className="text-sm text-carbon-500 mt-1.5 max-w-2xl">{description}</p>}
        </div>
        <div className="flex items-center gap-2">{children}</div>
      </div>
    </div>
  );
}

export function PageBody({ children }) {
  return <div className="px-10 py-8">{children}</div>;
}

export function Card({ children, className = "", testid }) {
  return (
    <div data-testid={testid} className={`bg-surface border border-carbon-200 rounded-lg ${className}`}>
      {children}
    </div>
  );
}

export function Badge({ children, tone = "neutral" }) {
  const tones = {
    neutral: "bg-carbon-100 text-carbon-700 border-carbon-200",
    terracotta: "bg-terracotta-light text-terracotta border-terracotta/30",
    forest: "bg-forest-light text-forest border-forest/30",
    warning: "bg-orange-50 text-warning border-warning/30",
    signal: "bg-red-50 text-signal border-signal/30",
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] uppercase tracking-wider border font-medium ${tones[tone] || tones.neutral}`}>
      {children}
    </span>
  );
}

export function useFetch(loader, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    loader()
      .then((d) => alive && setData(d))
      .catch((e) => alive && setError(e))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
    // eslint-disable-next-line
  }, [...deps, reloadKey]);

  return { data, loading, error, reload: () => setReloadKey((k) => k + 1), setData };
}
